import React, { useState, useEffect } from 'react'
import DateDisplay from './DateDisplay'
import DateSelector from './DateSelector'
import { EditableDate } from '@app-types/entity_types'
import { createLogger } from '@utils/logger'
import { InternalTimelineEditorValue } from '../TimelineEditor'

const log = createLogger('EnlargedTimelineEditor', { prependScope: true })
log.setLevel('info')

type EnlargedTimelineEditorProps = {
  value: InternalTimelineEditorValue
  onChange?: (value: InternalTimelineEditorValue) => void
}

const EnlargedTimelineEditor: React.FC<EnlargedTimelineEditorProps> = ({ value, onChange }) => {
  const [selectedValue, setSelectedValue] = useState<InternalTimelineEditorValue>(value)

  const handleDateSelectorChange = (obj: { name: 's' | 'e'; value: EditableDate | null }) => {
    log.debug('handleDateSelectorChange', { obj })

    const { name, value } = obj

    const nextSelectedValue = {
      ...selectedValue,
      [name]: value,
    }
    setSelectedValue(nextSelectedValue)

    if (onChange) {
      log.debug('calling onChange from EnlargedTimelineEditor with', nextSelectedValue)
      onChange(nextSelectedValue)
    }
  }

  useEffect(() => {
    setSelectedValue(value)
  }, [value])

  return (
    <div className="enlarged-timeline-editor">
      <div className="enlarged-timeline-editor__date-display block">
        <DateDisplay value={selectedValue} />
      </div>
      <p className="tip">
        If you don&apos;t select an end date, your item will be displayed as a single point in time.
      </p>
      <div className="enlarged-timeline-editor__date-selectors">
        <DateSelector
          value={selectedValue.s}
          name="s"
          label="Start date"
          onChange={handleDateSelectorChange}
          className="timeline-editor__date-selector block"
        />
        <DateSelector
          value={selectedValue.e}
          name="e"
          label="End date"
          onChange={handleDateSelectorChange}
          className="timeline-editor__date-selector block"
        />
      </div>
    </div>
  )
}

export default EnlargedTimelineEditor
